import { RegistrationController } from '../../controllers/registration-controller'
import { newInstance, autoinject } from 'aurelia-framework';
import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger, Validator } from 'aurelia-validation';
import { DefaultValidationRenderer } from "../../resources/renderers/default-validation-renderer";
import { PageMessageService } from "../../services/page-message-service";
import { BusyService } from "../../services/busy-service";
import { Carrier } from "../../models/carrier";
import { AppMessageService } from "../../services/app-message-service";

@autoinject
export class Begin {
    showConfirmation: boolean;

    constructor(public reg: RegistrationController,
        private controllerFactory: ValidationControllerFactory,
        private appMessageService: AppMessageService,
        private pageMessageService: PageMessageService,
        private busyService: BusyService
    ) {
        this.controller = controllerFactory.createForCurrentScope();
        this.controller.validateTrigger = validateTrigger.change;
        this.controller.addRenderer(new DefaultValidationRenderer());
    }


    canActivate(params): any {

        // ////enable this page as entry point for debugging (only for local environment)
        // if ((<any>this.aurelia.host.attributes).environment.value.toLowerCase() == "local") {
        //     if (!this.reg.carrier) {
        //         this.reg.carrier = new Carrier();
        //         this.reg.carrier.legalName = "DYNAMITE DOCUMENT DESTRUCTION";
        //         this.reg.carrier.dotNumber = "1232032";
        //     }
        //  }

        // don't allow user to navigate backwards after submitting the application
        if (this.reg.carrier && this.reg.carrier.isSubmitted) {
            return false;
        }
    }


    async activate(params) {
        if (!this.reg.requestId) {
            const requestid = params.id;
            await this.reg.loadCompanyInfo(requestid);
        }
        if (!this.reg.carrier) {
            this.legalName = "";
            this.dotNumber = "";
        } else {
            this.entityType = this.reg.carrier.entityType;
            this.legalName = this.reg.carrier.legalName;
            this.dotNumber = this.reg.carrier.dotNumber;
            this.typeOfAuthority = this.reg.carrier.typeOfAuthority;
            this.showConfirmation = true;
        }
    }

    controller: ValidationController = null;
    entityType: string = "";
    legalName: string = "";
    dotNumber: string = "";
    typeOfAuthority: string = "";

    recaptchaResponse: string = "";
    // legalName: string = "Scenic Scapes";
    // dotNumber: string = "1358366";

    recaptcha(response) {
        this.recaptchaResponse = response;
    }

    submit() {
        this.appMessageService.clearPageScopedMessages();
        this.controller.validate().then(v => {
            if (v.length === 0) {
                this.pageMessageService.clear();
                this.reg.verifyCompanyInfo();

                //this.busyService.on();
                //this.reg.verifyCompanyInfo(this.dotNumber, this.legalName, this.recaptchaResponse);
                //        .finally(() => {
                //            this.busyService.off();
                //            //recpatcha reset needs to be performed after the busyService has been turned off.
                //            this.recaptchaResponse = "";
                //            window["grecaptcha"].reset();
                //        });
            }
            else {
                this.pageMessageService.setDefaultValidationMessage();
            }
        });
    }
}

ValidationRules
    .ensure((m: Begin) => m.legalName).required()
    .ensure((m: Begin) => m.dotNumber).required()
    .ensure((m: Begin) => m.recaptchaResponse).required().withMessage('Please verify that you are not a robot.')
    .on(Begin);